import React from "react"

import { downloadUrlProxyfier } from "../../helper/downloadUrlProxyfier"
import DfbIcon from "../../components/ui-kit/dfb_icon"

const CDownloadList = ({ data }) => {
  const { download_list_item } = data

  return (
    <>
      {download_list_item && download_list_item.length > 0 && (
        <div className="c-DownloadList">
          <ul className="c-DownloadList-items">
            {download_list_item.map((item) => {
              return (
                <li
                  className="c-DownloadList-item"
                  key={item.download_list_item_title}
                >
                  <DfbIcon icon_type="download" />
                  <a
                    className="dfb-Textlink"
                    href={downloadUrlProxyfier(
                      item.download_list_item_file.src
                    )}
                    target="_blank"
                  >
                    {item.download_list_item_title}
                  </a>
                </li>
              )
            })}
          </ul>
        </div>
      )}
    </>
  )
}

export default CDownloadList
